import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=f396eb94"
import script from "./EmailInput.ts?vue&type=script&lang=ts&external"
export * from "./EmailInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports